import * as _ from 'lodash';

const DROP_KEYS = new Set(['builderElementPosition']);

const STYLE_DEFAULTS: Record<string, unknown> = {
  animationDelay: 0,
};

export function normalizeTemplate(template: unknown): unknown | unknown[] {
  if (template == null) {
    return undefined;
  }

  if (Array.isArray(template)) {
    return template.map(normalizeTemplate).filter(v => v !== undefined);
  }

  if (typeof template === 'object') {
    const templateOut: unknown = {};

    for (const [key, value] of Object.entries(template as Record<string, unknown>)) {
      if (DROP_KEYS.has(key)) continue;

      if (key === 'style' && value && typeof value === 'object') {
        const style: unknown = {};

        for (const [innerKey, innerValue] of Object.entries(value as Record<string, unknown>)) {
          if (innerValue === undefined || innerValue === null) {
            continue;
          }

          if (innerValue === '') {
            continue;
          }

          if (innerKey in STYLE_DEFAULTS && _.isEqual(innerValue, STYLE_DEFAULTS[innerKey])) {
            continue;
          }

          const normalized = normalizeTemplate(innerValue);

          if (normalized !== undefined) {
            style[innerKey] = normalized;
          }
        }

        if (Object.keys(style).length) {
          templateOut[key] = style;
        }

        continue;
      }

      const normalized = normalizeTemplate(value);

      if (normalized !== undefined) {
        templateOut[key] = normalized;
      }
    }

    return templateOut;
  }

  return template;
}

export function stableStringify(template: unknown): string {
  const seen = new WeakSet<object>();

  const sort = (templateValue: unknown): unknown => {
    if (templateValue == null) {
      return templateValue;
    }

    if (typeof templateValue !== 'object') {
      return templateValue;
    }

    if (seen.has(templateValue as object)) {
      return templateValue;
    }

    seen.add(templateValue as object);

    if (Array.isArray(templateValue)) {
      return templateValue.map(sort);
    }

    const keys = Object.keys(templateValue as Record<string, unknown>).sort();

    const templateOut: unknown = {};

    for (const key of keys) {
      templateOut[key] = sort((templateValue as unknown)[key]);
    }

    return templateOut;
  };

  return JSON.stringify(sort(template));
}

export function templateCompare(originalTemplate: unknown, template: unknown): boolean {
  const normalizedOriginalTemplate = normalizeTemplate(originalTemplate);
  const normalizedTemplate = normalizeTemplate(template);

  return stableStringify(normalizedOriginalTemplate) !== stableStringify(normalizedTemplate);
}
